import { render, staticRenderFns } from "./ClientTable.vue?vue&type=template&id=19b19ba4&"
import script from "./ClientTable.vue?vue&type=script&lang=js&"
export * from "./ClientTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports